import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Company, CompanyEvent } from '../alldocuments-companies.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CompaniesService } from '../companies.service';

@Component({
  selector: 'app-alldocuments-companies-mobile',
  templateUrl: './alldocuments-companies-mobile.component.html',
  styleUrls: ['./alldocuments-companies-mobile.component.scss']
})
export class AlldocumentsCompaniesMobileComponent implements OnInit, OnDestroy {
  @Input() selectedCompanyId: string | null = null;
  @Input() placeholder: string = 'allDocuments.filters.companies.placeholder';
  @Input() currentLang: string = 'en';
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;

  @Output() companyChange = new EventEmitter<CompanyEvent>();

  companies: Company[] = [];
  selectedCompany: Company | null = null;
  private destroy$ = new Subject<void>();
  showAllCompanies: boolean = false;

  constructor(private companiesService: CompaniesService) { }

  async ngOnInit(): Promise<void> {
    this.companies = await this.companiesService.getCompanies().toPromise();
    this.selectedCompany = null;

    // If we have a selectedCompanyId, find and select the matching company
    if (this.selectedCompanyId) {
      this.selectedCompany = this.companies.find(c => c.value === this.selectedCompanyId) || null;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleShowAllCompanies(): void {
    this.showAllCompanies = !this.showAllCompanies;
  }

  onCompanyChange(value: number): void {
    this.selectedCompany = this.companies.find(company => company.value === value) || null;
    this.companyChange.emit({
      value: value,
      originalEvent: undefined // No original event in mobile version
    });
  }

  isCompanySelected(company: Company): boolean {
    return this.selectedCompany?.value === company.value;
  }
}
